var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSingle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    id: "svg243",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs240"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m 23.06132,2.225227 a 17.851437,17.851437 0 0 1 4.54554,2.14312 13.607521,13.607521 0 0 1 2.02936,1.90765 c -0.56092,-0.26459 -2.63261,-0.7673 -4.07723,-0.88107 -3.22263,-0.26458 -6.55373,0.28575 -8.93763,1.48961 -5.34723,2.69346 -8.3581802,8.75241 -7.9983502,14.22929 0.50271,7.63058 6.9638302,15.37758 18.1266002,14.48594 -11.52525,7.27604 -28.0458301,-3.28877 -26.57739013,-17.06563 l -0.037,-0.50271 C 0.74375984,6.985077 12.53624,-1.0397331 23.06136,2.225227 Z",
    id: "path30",
    style: {
      fill: "#a1c74a",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M 39.15328,24.347037 C 31.93015,44.598247 2.4476298,32.133727 11.9594,12.893227 v 0 c 1.02394,-1.92353 2.11667,-2.9845 3.34963,-4.05607 a 11.52525,11.52525 0 0 1 2.11667,-1.38641 v 0 c -2.93159,5.55625 -3.24909,14.2187 1.95527,17.72708 -0.0741,-0.0529 0.30427,0.19844 0.30427,0.19844 7.27869,4.81541 18.45204,0.26458 19.6506,-8.42434 0,0 0.0317,-0.32543 0.0873,-0.10848 a 15.277041,15.277041 0 0 1 -0.26987,7.50359 z",
    id: "path32",
    style: {
      fill: "#175583",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m 38.97601,14.911997 c 0,0 -0.0635,0.49741 -0.17727,1.09273 a 11.432646,11.432646 0 0 1 -0.2884,1.16416 c -1.50812,5.29167 -6.68866,9.08844 -11.96975,8.86619 -1.85208,-0.0767 -4.42383,-0.58208 -6.15421,-1.6854 a 10.189104,10.189104 0 0 1 -2.45798,-2.44475 8.4005207,8.4005207 0 0 1 -1.05833,-2.1537 c 2.09021,1.47108 3.73592,1.65629 5.43719,1.85208 a 11.038417,11.038417 0 0 0 5.35517,-0.85461 c 5.21493,-2.18545 6.96383,-8.80797 3.92641,-13.75833 -1.69598,-2.75696 -5.88169,-5.64621 -10.47485,-5.90021 8.35289,-3.89996 19.22462,4.7625 17.86202,13.82184 z",
    id: "path34",
    style: {
      fill: "#70bde5",
      strokeWidth: 0.264583
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSingle);
export default __webpack_public_path__ + "static/media/Logo-single.ba792cc60cee57797f556206f284dd03.svg";
export { ForwardRef as ReactComponent };